<template>
    <jet-authentication-card class="bg-minplan-blue" :style="branding?.branding_navbar_color ? { backgroundColor: branding.branding_navbar_color } : {}">
        <template #logo>
            <img v-if="branding?.branding_logo_url" class="h-16 w-auto" :src="branding.branding_logo_url" :alt="agencyName" />
            <img v-else class="h-16 w-auto" src="../../../image/immivo.svg" alt="immivo" />
        </template>

        <h1 class="text-2xl font-bold leading-7 text-gray-900 text-center sm:truncate">
            {{ $t("auth.agencyInviteTitle", { agency: agencyName }) }}
        </h1>
        <p v-if="!hasPassword" class="text-center text-gray-500 my-3">
            {{ $t("auth.agencyInviteIntro", { user: userName, agency: agencyName }) }}
        </p>

        <p v-if="hasPassword" class="text-center text-gray-500 my-3">
            {{
                $t("auth.agencyInviteIntroNoPassword", {
                    user: userName,
                    agency: agencyName,
                })
            }}
        </p>

        <div class="text-center mt-3">
            <primary-button @click="join()" v-if="hasPassword">
                {{ $t("auth.acceptInvite") }}
            </primary-button>
        </div>

        <jet-validation-errors class="mb-4 mt-4" />

        <form v-if="!hasPassword" @submit.prevent="submit">
            <div class="mt-4">
                <jet-label for="password" :value="$t('auth.password')" />
                <jet-input
                    id="password"
                    type="password"
                    class="mt-1 block w-full"
                    v-model="form.password"
                    required
                    autocomplete="new-password"
                />
            </div>

            <div class="mt-4">
                <jet-label
                    for="password_confirmation"
                    :value="$t('auth.passwordRepeat')"
                />
                <jet-input
                    id="password_confirmation"
                    type="password"
                    class="mt-1 block w-full"
                    v-model="form.password_confirmation"
                    required
                    autocomplete="new-password"
                />
            </div>

            <div class="flex items-center justify-end mt-4">
                <primary-button
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                >
                    {{ $t("auth.passwordSet") }}
                </primary-button>
            </div>
        </form>
    </jet-authentication-card>
</template>

<script>
import { defineComponent } from "vue";
import { Head } from "@inertiajs/inertia-vue3";
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "@/Jetstream/AuthenticationCardLogo.vue";
import PrimaryButton from "@/Jetstream/PrimaryButton.vue";
import JetInput from "@/Jetstream/Input.vue";
import JetLabel from "@/Jetstream/Label.vue";
import JetValidationErrors from "@/Jetstream/ValidationErrors.vue";
import MainLayout from "@/Layouts/MainLayout";

export default defineComponent({
    components: {
        Head,
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        PrimaryButton,
        JetInput,
        JetLabel,
        JetValidationErrors,
    },
    props: ["token", "agencyName", "userName", "hasPassword", "branding"],
    data() {
        return {
            form: this.$inertia.form({
                password: "",
                password_confirmation: "",
            }),
        };
    },

    methods: {
        join: function () {
            this.$inertia.post(
                this.route("auth.agencies.accept-invite-no-pw", { token: this.token }),
                {},
                {
                    onSuccess: () =>
                        this.$notify({
                            group: "success",
                            title: "actions.success",
                            text: "auth.agencyJoined",
                        }),
                }
            );
        },
        submit() {
            this.form.post(
                this.route("auth.agencies.accept-invite", { token: this.token }),
                {
                    onSuccess: () =>
                        this.$notify({
                            group: "success",
                            title: "actions.success",
                            text: "auth.pwUpdated",
                        }),
                    onFinish: () => this.form.reset("password", "password_confirmation"),
                }
            );
        },
    },
});
</script>
